import { useAuth } from "../context/AuthContext";

// Wrap any UI fragment: only renders children if the current admin
// has the given permission key (or is the super admin).
export default function PermissionGate({ permission, children, fallback = null }) {
  const { can } = useAuth();
  return can(permission) ? children : fallback;
}
